import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'ss-table',
    templateUrl: './ss.table.component.html',
    styleUrls: ['./ss.table.component.scss']
})
export class SSTableComponent implements OnInit, OnChanges {

    Scrollable: boolean = false;

	@Input('Margin') Margin: boolean = true;
	@Input('Padding') Padding: boolean = true;
    @Input('Border') Border: boolean = true;
    @Input('TableLoaded') TableLoaded: boolean;

    @ViewChild('Table') Table: ElementRef;

    RightMargin: string = '20px';

    constructor() { }

    ngOnInit() {
        setTimeout( () => {
            this.DetectHeight();
        }, 200);

        $(window).resize(() => {
            this.DetectHeight();
        });

        if (!this.Margin) {
            this.RightMargin = '0';
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        setTimeout(() => {
            this.DetectHeight();
        }, 100);
    }

    DetectHeight() {
        let children = this.Table.nativeElement.children;

        let fixedHeight = this.Table.nativeElement.parentElement.parentElement.clientHeight;

        for (let i = 0; i < children.length; i++) {
            let child = children[i];
            let isTable = child.className.match(/^table\s/);

            if (isTable && isTable.length > 0) {
                if (child.scrollHeight + 40 > fixedHeight) {
                    this.Scrollable = true;
                } else {
                    this.Scrollable = false;
                }
            }
        }
    }

}
